import { UseCaseRecursoAsync } from "src/views/core/types/UseCaseRecursoAsync";
import { Recurso } from 'lib.common/dist/CleanArch';
import { ErrDevGenerico } from 'lib.common/dist/errorHandler';
import { EstadisticasCRMRepository } from "../repositories/EstadisticasCRMRepository";
import { ClientesSinContacto, EstadisticasCRM, EstadoProductosAnual, ResumenAtencion } from "../entities/EstadisticasCRM.entity";
import { FechaParams } from "../../utils/params/FechaParams.params";

export class GetResumenAtencionesUseCase<
    T_OUT extends EstadisticasCRM,
    T_OUT2 extends ClientesSinContacto,
    T_OUT3 extends ResumenAtencion,
    T_OUT4 extends EstadoProductosAnual
> extends UseCaseRecursoAsync<
    FechaParams,
    T_OUT3[]
> {
    private repository: EstadisticasCRMRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>;
    constructor(repository: EstadisticasCRMRepository<T_OUT, T_OUT2, T_OUT3, T_OUT4>) {
        super();
        this.repository = repository;
    }

    async call(input: FechaParams): Promise<Recurso<T_OUT3[]>> {
        try {
            return this.repository.getResumenAtenciones(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT3[]>(errorCapa);
        }
    }
}